import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router';
import { ReserviertInhalt } from '@/components/reserviert/ReserviertInhalt';

// „Ist dieses Exemplar für jemanden reserviert?" (#59, A27) — die Seite.
// Der Inhalt (Feld, Antwortsatz, Treffer) steht seit 02.11.2026 in
// components/reserviert/ReserviertInhalt.tsx, weil dasselbe auch als Blatt
// über jeder Seite liegt (ReserviertBlatt.tsx). Die Begründungen dazu
// stehen dort.

// Der gefragte Begriff steht in der Adresse (Befund 29.10.2026): Wer
// aus einem Treffer in die Bestellung geht und zurückkommt, findet
// Frage und Antwort wieder vor.
type ReserviertSuche = { q?: string };

export const Route = createFileRoute('/reserviert')({
  validateSearch: (s: Record<string, unknown>): ReserviertSuche =>
    typeof s.q === 'string' && s.q.trim() !== '' ? { q: s.q } : {},
  component: ReserviertSeite
});

function ReserviertSeite() {
  const { q: ausAdresse } = useSearch({ strict: false }) as ReserviertSuche;
  const navigate = useNavigate();

  function fragen(begriff: string): void {
    // Ersetzen, nicht hinzufügen: Jede Frage ist kein eigener Ort, zu
    // dem „Zurück" führen soll.
    void navigate({
      to: '/reserviert',
      search: begriff === '' ? {} : { q: begriff },
      replace: true
    } as never);
  }

  return (
    <div className="mx-auto w-full max-w-3xl space-y-5 p-4">
      <header className="space-y-1">
        <h1 className="font-serif text-2xl text-ink">Reserviert?</h1>
        <p className="text-sm text-ink-soft">
          Liegt dieses Buch schon für jemanden im Regal? Titel oder ISBN eingeben — gesucht
          wird in allen offenen Bestellungen, auch in denen, die an BONUS vorbeilaufen.
        </p>
      </header>
      <ReserviertInhalt begriff={ausAdresse ?? ''} onFragen={fragen} />
    </div>
  );
}

